import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'

const ActionButton3 = () => {

    const [isActive, setIsActive] = useState(true);

    const handleActive = () => {
        confirmAlert({
            message: "Are you sure you want to change the status?",
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => setIsActive(!isActive)
                },


                {
                    label: 'Cancel',
                    onClick: () => setIsActive(true)
                }
            ],
            overlayClassName: "react-confirm-alert-overlay react-confirm-alert-body"
        });
    };

    const handleInactive = () => {
        confirmAlert({
            message: "Are you sure you want to change the status?",
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => setIsActive(!isActive)
                },
                {
                    label: 'Cancel',
                    onClick: () => setIsActive(false)
                }
            ],
        });
    };

    const editItem = () => {
        
    }

    

    return (
        <>
            <div className='flex items-center justify-center flex-wrap sm:flex-nowrap gap-2 w-full'>
                <Link to="/Admin/Template/Edit" className='bg-blue-600 text-white h-7 w-7 leading-7 rounded-sm text-center cursor-pointer hover:bg-blue-700 animation'>
                    <i className="fa-regular fa-pen-to-square" onClick={()=>editItem()}></i>
                </Link>

                {isActive ? <div className='block bg-[#30c381] h-7 w-20 text-center leading-7 text-white text-sm font-medium rounded-sm cursor-pointer hover:bg-[#21af6f] animation' onClick={handleActive} >
                    <i className="fa-regular fa-circle-check mr-[2px]"></i>
                    Active
                </div> : <div className='block bg-[#eba610] h-7 w-20 text-center leading-7 text-white text-sm font-medium rounded-sm cursor-pointer hover:bg-[#e2b41c] animation' onClick={handleInactive}>
                    <i className="fa-regular fa-circle-xmark mr-[2px]"></i>
                    Inactive
                </div>}
            </div>
        </>
    )
}

export default ActionButton3
